export const publishersConstants = {
  SET_PUBLISHERS: 'SET_PUBLISHERS',
  SELECT_PUBLISHERS: 'SELECT_PUBLISHERS',
  FETCH_PUBLISHERS: 'FETCH_PUBLISHERS',
  VALIDATE_PUBLISHER_STORE: 'VALIDATE_PUBLISHER_STORE',
};
